/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
import { MLHVQDiscrepancyPropertyColomnComponent } from 'gw-capability-quoteandbind-pa-react';

import MLCRVehiclesNonDiscrepanciesComponent from './MLCRVehiclesNonDiscrepanciesComponent/MLCRVehiclesNonDiscrepanciesComponent';

import metadata from './MLCRVehiclesValidationComponent.metadata.json5';
import styles from './MLCRVehiclesValidationComponent.module.scss';


function MLCRVehiclesValidationComponent(props) {
    const {
        discrepanciesVM,
        vehiclesVM,
        submissionVM,
        onValidate,
        showValidationErrors
    } = props;

    const vehicleHasDiscrepancy = (vehVM) => {
        return discrepanciesVM.some((disVM) => {
            const publicId = disVM.publicId;

            return vehVM.value.publicID === publicId;
        });
    }

    const getVehicleDiscrepancy = (vehVM) => {
        if (vehicleHasDiscrepancy(vehVM)) {
            const vehDiscrepancyVM = discrepanciesVM.find((disVM) => {
                return vehVM.value.publicID === disVM.publicId;
            });

            return vehDiscrepancyVM?.propertyVMs;
        }
    }

    const generateOverrides = () => {
        const data = vehiclesVM.length > 0 ? vehiclesVM : [];

        if (data.length > 0) {
            const vehicleOverrides = data.map((vehicleVM, index) => {
                return {
                    [`VehicleName${index}`]: {
                        visible: !vehicleHasDiscrepancy(vehicleVM),
                        content: vehicleVM.value?.displayName
                    },
                    [`DiscrepancyProperty${index}`]: {
                        visible: vehicleHasDiscrepancy(vehicleVM),
                        discrepancyProperties: getVehicleDiscrepancy(vehicleVM),
                        discrepancyOwnerTitle: vehicleVM.value?.displayName,
                        showPropertyGroupDoubleBorderStyle: false,
                        discrepancyHasUpdated: () => {}
                    },
                    [`NonDiscrepancyProperty${index}`]: {
                        vehicleVM: vehicleVM,
                        submissionVM: submissionVM,
                        onValidate: onValidate,
                        showValidationErrors,
                        id: `NonDiscrepancyProperty${index}`
                    }
                };
            });

            return Object.assign({}, ...vehicleOverrides);
        }

        return {};
    };

    const overrideProps = {
        vehiclesDiscrepancy: {
            data: vehiclesVM
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveComponentMap: {
            discrepancyPropertyComponent: MLHVQDiscrepancyPropertyColomnComponent,
            nonDiscrepancyPropertyComponent: MLCRVehiclesNonDiscrepanciesComponent
        },
        resolveClassNameMap: styles
    }

    // Hide component when no discrepency
    if(vehiclesVM.length === 0) {
        return null;
    }

    return (
        <ViewModelForm
            model={vehiclesVM}
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={onValidate}
            showErrors={showValidationErrors}
        />
    );
}

MLCRVehiclesValidationComponent.propTypes = {
    discrepanciesVM: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    vehiclesVM: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    submissionVM: PropTypes.shape({}).isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
};
MLCRVehiclesValidationComponent.defaultProps = {

};
export default withRouter(MLCRVehiclesValidationComponent);
